<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <div class="grid grid-cols-2 gap-2">
            <div class="flex justify-start">
                <div class="w-19 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button
                    class="btn btn-outline btn-default dt-download mx-2 group"
                    [matMenuTriggerFor]="downloadMenu"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"
                    ></mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="downloadFieldsSummaryExcel()">
                        <span>Excel</span>
                    </button>
                </mat-menu>
            </div>
            <div class="flex justify-end">
                <app-single-filter
                    [searchForm]="searchForm"
                    [filterBy]="'Field'"
                    class="text-primary w-64"
                ></app-single-filter>

                <button
                    class="btn btn-primary mx-2"
                    (click)="setPage({ offset: 0 })"
                >
                    Search
                </button>

                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button
                    class="btn btn-outline btn-default mx-2 group"
                    (click)="setPage({ offset: dt.page.offset })"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-path"
                    ></mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div
            class="table-moc-field-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort
            matSortDisableClear
        >
            <div class="border py-8 text-center"></div>

            <div class="border py-8 text-center">No</div>

            <div
                [mat-sort-header]="'fieldLongName'"
                class="flex justify-center border py-8"
            >
                Field
            </div>

            <div
                [mat-sort-header]="'platformLongName'"
                class="flex justify-center border py-8"
            >
                Platform
            </div>

            <div class="flex justify-center border py-8">Well</div>

            <div class="flex justify-center border py-8">Well String</div>

            <div class="flex justify-center border py-8">String Indicator</div>

            <div class="flex justify-center border py-8">Title</div>

            <div class="flex justify-center border py-8">Ref No</div>

            <div class="flex justify-center border py-8">Extension No</div>

            <div class="flex justify-center border py-8">Start Date</div>

            <div class="flex justify-center border py-8">End Date</div>

            <div class="flex justify-center border py-8">Key Issues</div>

            <div class="flex justify-center border py-8">Stage</div>

            <div class="flex justify-center border py-8">Closed Date</div>

            <div class="flex justify-center border py-8">Requested By</div>

            <div class="flex justify-center border py-8">Status</div>

            <div class="flex justify-center border py-8">Approved Status</div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container
                *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn"
            >
                <div
                    class="table-moc-field-summary-grid grid items-center border-b"
                    [ngClass]="{ 'bg-primary-100': i % 2 }"
                >
                    <!-- Expand Icon -->
                    <button
                        class="py-4 text-center cursor-pointer w-full flex justify-center items-center"
                        (click)="toggleExpandRow(row)"
                    >
                        <mat-icon
                            [svgIcon]="
                                row.expanded
                                    ? 'heroicons_mini:minus'
                                    : 'heroicons_mini:plus'
                            "
                        ></mat-icon>
                    </button>

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{ startingIndex + i + 1 }}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Plaform Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- Well String Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.stringShortName || "-" }}
                    </div>

                    <!--  String Indicator -->
                    <div class="flex truncate justify-center">
                        {{ row.stringIndicatorShortName || "-" }}
                    </div>

                    <!-- Title -->
                    <div class="flex truncate justify-center">
                        {{ row.title }}
                    </div>

                    <!-- ref No -->
                    <div class="flex truncate justify-center">
                        {{ row.refNo }}
                    </div>

                    <!-- extension no  -->
                    <div class="flex truncate justify-center">
                        {{ row.extNo }}
                    </div>

                    <!-- start date -->
                    <div class="flex truncate justify-center">
                        {{ row.startDate }}
                    </div>

                    <!-- end date -->
                    <div class="flex truncate justify-center">
                        {{ row.endDate }}
                    </div>

                    <!-- key issue -->
                    <div class="flex truncate justify-center">
                        {{ row.keyIssues }}
                    </div>

                    <!-- stage -->
                    <div class="flex truncate justify-center">
                        {{ row.stage }}
                    </div>

                    <!-- closed date -->
                    <div class="flex truncate justify-center">
                        {{ row.closeDate }}
                    </div>

                    <!-- requested by -->
                    <div class="flex truncate justify-center">
                        {{ row.requestBy }}
                    </div>

                    <!-- status -->
                    <div class="flex truncate justify-center">
                        {{ row.status }}
                    </div>

                    <!-- approval status -->
                    <div class="flex truncate justify-center">
                        {{ row.approvalStatus }}
                    </div>
                </div>

                <!-- Expand Row -->
                <div
                    *ngIf="row.expanded"
                    class="table-moc-field-summary-grid grid items-center border-b"
                    [ngClass]="{ 'bg-primary-100': i % 2 }"
                >
                    <ng-container
                        *ngFor="
                            let rowChild of row.lists;
                            let i = index;
                            trackBy: trackByFn
                        "
                    >
                        <div class="my-8"></div>
                        <div></div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.fieldLongName }}
                        </div>

                        <!-- Plaform Long Name -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.platformLongName }}
                        </div>

                        <!-- Well Long Name -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.wellLongName }}
                        </div>

                        <!-- Well String Long Name -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.stringShortName || "-" }}
                        </div>

                        <!--  String Indicator -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.stringIndicatorShortName || "-" }}
                        </div>

                        <!-- Title -->
                        <div
                            class="flex truncate justify-center whitespace-normal break-words text-center"
                        >
                            {{ rowChild.title }}
                        </div>

                        <!-- ref No -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.refNo || "-" }}
                        </div>

                        <!-- extension no  -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.extNo || "-" }}
                        </div>

                        <!-- start date -->
                        <div class="flex truncate justify-center">
                            {{ handleFormatDate(rowChild.startDate, false) }}
                        </div>

                        <!-- end date -->
                        <div class="flex truncate justify-center">
                            {{ handleFormatDate(rowChild.endDate, false) }}
                        </div>

                        <!-- key issue -->
                        <div
                            class="flex truncate justify-center whitespace-normal break-words text-center"
                        >
                            {{ rowChild.keyIssues || "-" }}
                        </div>

                        <!-- stage -->
                        <div
                            class="flex truncate justify-center whitespace-normal break-words text-center"
                        >
                            {{ rowChild.stage || "-" }}
                        </div>

                        <!-- closed date -->
                        <div class="flex truncate justify-center">
                            {{
                                handleFormatDate(rowChild.closeDate, false) ||
                                    "-"
                            }}
                        </div>

                        <!-- requested by -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.requestBy }}
                        </div>

                        <!-- status -->
                        <div
                            class="flex truncate justify-center mx-2"
                            [ngClass]="{
                                idleBadge: rowChild.status == mocStatus.ACTIVE,
                                successBadge:
                                    rowChild.status == mocStatus.CLOSED ||
                                    rowChild.status == mocStatus.CLOSEOUT,
                                failedBadge:
                                    rowChild.status == mocStatus.REJECTED ||
                                    rowChild.status == mocStatus.CANCELLED,
                                warningBadge:
                                    rowChild.status ==
                                        mocStatus.APPROVALPROCESS ||
                                    rowChild.status ==
                                        mocStatus.EXTENSIONAPPROVALPROCESS,
                            }"
                        >
                            {{ rowChild.status }}
                        </div>

                        <!-- approval status -->
                        <div
                            class="flex truncate justify-center mx-2"
                            [ngClass]="{
                                successBadge:
                                    rowChild.approvalStatus ==
                                    mocApprovalStatus.APPROVED,
                                failedBadge:
                                    rowChild.approvalStatus ==
                                    mocApprovalStatus.REJECTED,
                                warningBadge:
                                    rowChild.approvalStatus ==
                                    mocApprovalStatus.PENDING,
                            }"
                        >
                            {{ rowChild.approvalStatus }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div
                class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center"
            >
                There are no Records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
    >
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }}
            {{ dt.page.totalRecords <= 1 ? "total" : "totals" }}
        </div>

        <mat-paginator
            class="bg-gray-50"
            [ngClass]="{ 'pointer-events-none': isLoading }"
            [length]="dt.page?.totalRecords"
            [pageIndex]="dt.page.offset"
            [pageSize]="dt.page.size"
            [hidePageSize]="true"
            [showFirstLastButtons]="true"
        >
        </mat-paginator>
    </div>
</div>
